module.exports = __webpack_public_path__ + "static/media/home-development-img-1.a0e46e1c.svg";